@let isArabic = isArabic$ | async;

<div class="profile-header d-flex align-items-center mb-3">
  <div class="profile-heading d-flex align-items-center">
    <button
      class="bi h2 text-primary bg-dark rounded"
      [ngClass]="isArabic ? 'bi-arrow-right-short ms-2' : 'bi-arrow-left-short me-2'"
      (click)="goBack()"
    ></button>
    <h2 class="mb-0">
      {{ isMyPage ? ('USER_DETAILS_MY_TITLE' | translate) : ('USER_DETAILS_TITLE' | translate) }}
    </h2>
  </div>
  @if (!loading && !isMyPage) {
    @if (user$ | async; as user) {
      <div class="profile-actions d-flex align-items-center gap-2">
        <app-report-ad [userId]="user.id" [profileImage]="user.officePhotoUrl" />
        <app-user-safety-actions [userId]="user.id" [userName]="user.name" />
      </div>
    }
  }
</div>

@if (loading) {
  <div class="text-center my-3">
    <app-loading></app-loading>
  </div>
} @else {
  @if (user$ | async; as user) {
    @if (isEditing) {
      <form [formGroup]="form" class="w-100">
        <div
          class="row mx-0 mb-0 text-primary bg-dark border border-1 border-primary rounded rounded-3 p-3 position-relative"
        >
          <div class="col-md-6 col-sm-12">
            <div class="col-lg-8 col-md-12 mb-3">
              <label class="pe-2">{{ 'NAME' | translate }}</label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control d-inline-block"
                  formControlName="name"
                  [ngClass]="{ 'is-invalid': isSubmitted && formControls['name'].invalid }"
                />
                <div class="text-light align-content-center px-1">
                  {{ name?.value?.length || 0 }}/25
                </div>
              </div>
              @if (name?.invalid && name?.touched) {
                <div class="invalid-feedback d-block">
                  @if (name?.errors?.['required']) {
                    <div>{{ 'NAME_REQUIRED' | translate }}</div>
                  }
                  @if (name?.errors?.['minlength']) {
                    <div>{{ 'VALID_NAME_MIN_LENGTH' | translate }}</div>
                  }
                  @if (name?.errors?.['maxlength']) {
                    <div>{{ 'VALID_NAME_MAX_LENGTH' | translate }}</div>
                  }
                </div>
              }
            </div>
            <div class="col-lg-8 col-md-12 mb-3">
              <label class="pe-2">{{ 'EMAIL' | translate }}</label>
              <input class="form-control" formControlName="email" />
            </div>
            <div class="col-lg-8 col-md-12 mb-3 contact-number-input">
              <label class="pe-2">
                {{ 'MOBILE' | translate }}
              </label>

              <app-phone-number-input
                formControlName="phoneNumber"
                [required]="true"
                defaultCountry="SY"
                label="MOBILE"
                hint="REGISTER_PHONE_HINT"
              ></app-phone-number-input>

              @if (phoneNumber?.invalid && (phoneNumber?.touched || isSubmitted)) {
                <div class="invalid-feedback d-block">
                  @if (phoneNumber?.errors?.['required']) {
                    <div>
                      {{ 'PHONE_REQUIRED' | translate }}
                    </div>
                  }

                  @if (phoneNumber?.errors?.['invalidPhoneNumber']) {
                    <div>
                      {{ 'VALID_PHONE_PETTERN' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-lg-8 col-md-12 mb-3" *hasRole="[roles.Admin, roles.Editor]">
              <label class="pe-2">{{ 'STATUS' | translate }}</label>
              <app-dropdown-checkbox-select
                id="statusSelect"
                class="required multi-line-select"
                [items]="statusOptions"
                formControlName="status"
                placeholder="{{ 'STATUS' | translate }}"
                [selectableGroup]="false"
                [isMultiple]="false"
                [closeOnSelect]="true"
                bindLabel="description"
              >
              </app-dropdown-checkbox-select>
            </div>
            <div class="col-lg-8 col-md-12 mb-3" *hasRole="[roles.Admin, roles.Editor]">
              <label class="pe-2">{{ 'PLAN' | translate }}</label>
              <app-dropdown-checkbox-select
                id="planSelect"
                class="required multi-line-select"
                [items]="planOptions"
                formControlName="plan"
                placeholder="{{ 'PLAN' | translate }}"
                [selectableGroup]="false"
                [isMultiple]="false"
                [closeOnSelect]="true"
                bindLabel="description"
              >
              </app-dropdown-checkbox-select>
            </div>
            <div class="col-lg-8 col-md-12 mb-3" *hasRole="[roles.Admin, roles.Editor]">
              <label class="pe-2">{{ 'PLAN_EXTENSION_PERIOD' | translate }}</label>
              <ng-select
                [items]="planExtenstionOptions"
                placeholder="{{ 'PLAN_EXTENSION_PERIOD' | translate }}"
                formControlName="planUpgradeMonths"
                bindValue="code"
                bindLabel="value"
                [searchable]="false"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.value | translate }}
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                  {{ item.value | translate }}
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-8 col-md-12 mb-3">
              <div class="row g-2">
                <app-location-picker
                  [longitude]="user?.longitude"
                  [latitude]="user?.latitude"
                  (locationPicked)="locationPicked($event)"
                ></app-location-picker>
              </div>
              <div *ngIf="!latitude?.value && latitude?.touched" class="text-danger small mt-2">
                {{ 'LOCATION_REQUIRED' | translate }}
              </div>
            </div>
            <div class="col-lg-8 col-md-12 mb-3">
              <label class="pe-2">{{ 'CAR_NEW_SELECT_CITY' | translate }}</label>
              <input
                formControlName="city"
                type="text"
                class="form-control mb-3"
                placeholder="{{ 'CAR_NEW_SELECT_CITY' | translate }}"
              />
              <label class="pe-2">{{ 'ADDRESS' | translate }}</label>
              <textarea
                class="form-control"
                formControlName="addressText"
                id="addressText"
                rows="3"
                placeholder="{{ 'ADDRESS' | translate }}"
              ></textarea>
            </div>
            <div class="col-lg-8 col-md-12 mb-3 contact-number-input">
              <label class="pe-2">
                {{ 'OFFICE' | translate }}
              </label>

              <app-phone-number-input
                formControlName="officePhoneNumber"
                [required]="false"
                defaultCountry="SY"
                label="OFFICE"
                hint=""
              ></app-phone-number-input>

              @if (officePhoneNumber?.invalid && (officePhoneNumber?.touched || isSubmitted)) {
                <div class="invalid-feedback d-block">
                  @if (officePhoneNumber?.errors?.['invalidPhoneNumber']) {
                    <div>
                      {{ 'VALID_PHONE_PETTERN' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-lg-8 col-md-12 mb-3">
              <label class="pe-2">{{ 'USER_DETAILS_DESCRIPTION' | translate }}</label>
              <textarea
                class="form-control"
                formControlName="description"
                id="description"
                rows="7"
                placeholder="Description"
              ></textarea>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="pe-2"></label>
            <!-- Choose File -->
            <input
              type="file"
              class="form-control"
              (change)="onFileSelected($event)"
              accept="image/*"
            />

            <div class="d-flex flex-wrap gap-3 mt-2">
              @if (photoUrl && !selectedFilePreview) {
                <div class="thumbnail-container">
                  <img
                    [src]="photoUrl"
                    loading="lazy"
                    alt="Existing image"
                    class="img-thumbnail thumbnail-image car-img"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger remove-btn"
                    [disabled]="loading"
                    (click)="removeExistingPicture()"
                  >
                    ×
                  </button>
                </div>
              }

              @if (selectedFilePreview) {
                <div class="thumbnail-container">
                  <img
                    [src]="selectedFilePreview"
                    loading="lazy"
                    alt="Selected image"
                    class="img-thumbnail thumbnail-image car-img"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger remove-btn"
                    [disabled]="loading"
                    (click)="removeImage()"
                  >
                    ×
                  </button>
                </div>
              }
            </div>
          </div>
          <div class="col-md-6 col-sm-12 mt-3">
            <div *canEdit="user.id" [ngClass]="isArabic ? 'edit-button-ar' : 'edit-button-en'">
              <button
                class="btn btn-sm btn-primary mx-1"
                (click)="save()"
                [disabled]="form.invalid || loading || !form.dirty"
              >
                @if (loading) {
                  <app-loading
                    class="align-content-center"
                    [height]="20"
                    theme="dark"
                  ></app-loading>
                }
                <i class="bi bi-floppy-fill"></i>
              </button>
              <button class="btn btn-sm btn btn-secondary bg-black text-primary" (click)="cancel()">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    } @else {
      <div
        class="row mx-0 mb-0 text-primary bg-dark border border-1 border-primary rounded rounded-3"
      >
        @if (isMyPage) {
          @if (user.status === statuses.Pending) {
            <button class="btn btn-primary" (click)="openModal(user)">
              <span class="badge rounded-pill bg-danger">
                i
                <span class="visually-hidden">unread messages</span>
              </span>
              {{ 'ACCOUNT_ACTIVATE' | translate }}
            </button>
          }
          @if (user.status === statuses.Blocked) {
            <div class="col-12 text-danger m-2">
              <i class="bi bi-info-circle-fill"></i
              ><span class="badge rounded-pill bg-danger">
                i
                <span class="visually-hidden">unread messages</span> </span
              >{{ 'ACCOUNT_BLOCKED' | translate }}
            </div>
          }
        }

        <div class="col-md-6 col-sm-12">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="card-title py-3">
                <strong>{{ user.name }}</strong>
                @if (
                  (user.plan === plans.Pro ||
                    user.plan === plans.Flex ||
                    user.plan === plans.Unlimited) &&
                  user.isPlanActive
                ) {
                  <app-plan-type
                    [plan]="user.plan"
                    [height]="30"
                    classes="align-top px-2"
                  ></app-plan-type>
                }
                @if (!isAdminEdit && !isOtherEditorEdit) {
                  <span *canEdit="user.id" class="align-top px-2">
                    <button
                      class="btn btn-sm btn-outline-primary me-1 mb-2"
                      (click)="toggleEdit(user)"
                    >
                      <i class="bi bi-pen-fill"></i>
                    </button>
                    @if (isMyPage) {
                      <a
                        class="btn btn-sm btn-outline-primary me-1 mb-2"
                        routerLink="/update-password"
                      >
                        {{ 'PASSWORD_UPDATE_TITLE' | translate }}
                      </a>
                    }
                  </span>
                }
              </h3>
            </div>
          </div>
          <div class="col-12">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'EMAIL' | translate }}: </span
              ><strong>{{ user.email }}</strong>
            </p>
          </div>
          @if (user.phoneNumber) {
            <div class="col-12">
              <p>
                <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                  >{{ 'MOBILE' | translate }}:</span
                >

                <strong class="phone-number-text">{{ user.phoneNumber }}</strong>
              </p>
            </div>
          }
          <div class="col-12">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'USER_DETAILS_JOINED' | translate }}:</span
              >

              <strong>{{ user.createdAt | date: 'dd.MM.yyyy' }}</strong>
            </p>
          </div>
          <div class="col-12" *hasRole="[roles.Admin, roles.Editor]">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'STATUS' | translate }}:</span
              >

              <strong>{{ user.status | translate }}</strong>
            </p>
          </div>
          <div class="col-12" *hasRole="[roles.Admin, roles.Editor]">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'USERS_SEARCH_ROLE' | translate }}:</span
              >

              <strong>{{ user.role && user.role !== '' ? user.role : '-' }}</strong>
            </p>
          </div>
          <div class="col-12">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'PLAN' | translate }}:</span
              >

              <strong class="ps-2"
                >{{ user.plan | translate }}
                <span *canEdit="user.id">
                  @if (user.plan !== plans.Flex) {
                    ({{ 'VALID_TO' | translate }} {{ user.planExpiresAt | date: 'dd.MM.yyyy' }})
                  }
                </span>
              </strong>
            </p>
          </div>
          <div class="col-12">
            <p class="text-light">{{ 'ADDRESS' | translate }}:</p>
            <p class="text-pre-line">
              <strong>{{ user.city | syrianCity }}</strong>
            </p>
            @if (user.addressText; as addressText) {
              <p class="text-pre-line">
                <strong>{{ addressText }}</strong>
              </p>
            }
            @if (user.latitude && user.longitude) {
              <p>
                <app-google-maps-location
                  [lat]="user.latitude"
                  [lng]="user.longitude"
                ></app-google-maps-location>
              </p>
            }
            @if (user.latitude && user.longitude) {
              <app-item-location [latitude]="user.latitude" [longitude]="user.longitude" [zoom]="7">
              </app-item-location>
            }
          </div>
          <div class="col-12 pt-3">
            <p>
              <span class="text-light" [ngClass]="isArabic ? 'ps-2' : 'pe-2'"
                >{{ 'OFFICE' | translate }}:</span
              >

              <strong class="ps-2 phone-number-text">{{ user.officePhoneNumber }}</strong>
            </p>
          </div>
          <div class="col-12">
            <p class="text-light">{{ 'USER_DETAILS_DESCRIPTION' | translate }}:</p>
            <p class="text-pre-line">
              <strong>{{ user.description }}</strong>
            </p>
            @if (isMyPage) {
              <button
                class="btn btn-sm btn-outline-danger me-1 mb-2"
                (click)="confirmDeleteAccount()"
              >
                <i class="bi bi-trash-fill"></i> {{ 'ACCOUNT.DELETE_ACCOUNT' | translate }}
              </button>
            }
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          @if (user.officePhotoUrl && user.isPlanActive) {
            <p class="py-3">
              <img
                [src]="user.officePhotoUrl"
                loading="lazy"
                alt="Dealer image"
                class="img-thumbnail thumbnail-image car-img"
              />
            </p>
          }
        </div>
      </div>
    }

    @if (user.cars.length > 0) {
      <div class="mx-0 mt-4">
        <h2>
          {{
            isMyPage ? ('USER_DETAILS_MY_CARS' | translate) : ('USER_DETAILS_USER_CARS' | translate)
          }}
        </h2>
        <car-list [cars]="user.cars"></car-list>
      </div>
    }

    @if (user.likedCars.length > 0) {
      <div class="mx-0 mt-4" *canEdit="user.id">
        <h2>
          {{ 'USER_DETAILS_USER_LIKED_CARS' | translate }}
        </h2>
        <car-list [cars]="user.likedCars" listId="likedCars"></car-list>
      </div>
    }

    @if (user.realEstates.length > 0) {
      <div class="mx-0 mt-4">
        <h2>
          {{
            isMyPage
              ? ('USER_DETAILS_MY_PROPERTIES' | translate)
              : ('USER_DETAILS_USER_PROPERTIES' | translate)
          }}
        </h2>
        <app-property-list [properties]="user.realEstates"></app-property-list>
      </div>
    }

    @if (user.likedRealEstates.length > 0) {
      <div class="mx-0 mt-4" *canEdit="user.id">
        <h2>
          {{ 'USER_DETAILS_USER_LIKED_PROPERTIES' | translate }}
        </h2>
        <app-property-list
          [properties]="user.likedRealEstates"
          listId="likedProperties"
        ></app-property-list>
      </div>
    }
  }
}

@if (showDeleteAccountConfirmation) {
  <div class="delete-account-backdrop" (click)="cancelDeleteAccount()">
    <div
      class="border border-primary delete-account-dialog p-4 bg-black rounded-3 text-center"
      role="alertdialog"
      aria-modal="true"
      [attr.aria-labelledby]="'delete-account-title'"
      (click)="$event.stopPropagation()"
    >
      <div class="delete-account-icon">!</div>

      <h2 class="fs-2 my-3 text-light">
        {{ 'ACCOUNT.DELETE_TITLE' | translate }}
      </h2>

      <p class="text-light">
        {{ 'ACCOUNT.DELETE_MESSAGE' | translate }}
      </p>

      <div class="d-flex justify-content-around">
        <button type="button" class="btn btn-primary" (click)="cancelDeleteAccount()">
          {{ 'CANCEL' | translate }}
        </button>

        <button type="button" class="btn btn-danger" (click)="confirmAccountDeletion()">
          {{ 'ACCOUNT.DELETE_CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </div>
}
